import { DatePipe } from '@angular/common';
import { Component, ViewChild, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { BusinessService } from '@app/business/business.service';
import { SessionStorageService, selectorAuth } from '@app/core';
import { InfoService } from '@app/core/info/info.service';
import { IUserData } from '@app/profile/main/details';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { CloudWebIdentificationHistoryDetailsComponent } from '../cloud-web-identification-history-details/cloud-web-identification-history-details.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { getWebIdentificationStatus, WebIdentificationStatusResult } from '@app/shared/helpers/web-identification-status.helper';

@Component({
  selector: 'cloud-business-web-indentification',
  templateUrl: './business-web-indentification.component.html',
  styleUrls: ['./business-web-indentification.component.scss']
})
export class BusinessWebIndentificationComponent implements OnInit {
  identificatorWEBForm!: FormGroup;
  status = [];
  readonly displayedColumns = [
    'status',
    'registrationTime',
    'name',
    'email',
    'phone',
    'actions'
  ];
  idintificatorDataSource!: MatTableDataSource<any>;
  allData: any[] = [];
  loading = false;
  isLoading = true;
  userData!: IUserData;
  companyCmrId: any;
  callbackId: any;
  offset: number = 0;
  limit: number = 10;
  totalCountPages: any;
  totalPages: any;
  websessionId: any;
  signsessionId: any;
  idResult: any;
  dataDialog: any;
  expiredsList: { value: boolean | null, label: string }[] = [
      { value: null, label: 'businessTexts.allExpired' },
      { value: true, label: 'businessTexts.expired' },
      { value: false, label: 'businessTexts.notExpired' }
    ];
  lastSort: { active: string, direction: "asc" | "desc" } = { active: '', direction: 'asc' };

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  private cancelRequest$ = new Subject<void>();

  constructor(
    private formBuilder: FormBuilder,
    private translateService: TranslateService,
    private store: Store<any>,
    private sessionStorageService: SessionStorageService,
    private businessService: BusinessService,
    public info: InfoService,
    public dialog: MatDialog,
  ) { }

  onSortChange(event: any) {
    this.lastSort = event;
    this.paginator.pageIndex = 0;
    this.resetAndLoadCertificates();
  }

  ngOnInit(): void {
    // Initialize dataSource with all data for table display only
    this.idintificatorDataSource = new MatTableDataSource<any>([]);
    
    // Define custom sort accessor for all columns
    this.idintificatorDataSource.sortingDataAccessor = (item, property) => {
      switch(property) {
        case 'registrationTime':
          return new Date(item.createdAt).getTime();
        case 'name':
          // Sort by current language (BG or EN)
          return this.lang === 'bg' ? (item.name?.bg || '').toLowerCase() : (item.name?.en || '').toLowerCase();
        case 'status':
          return (item.status || '').toLowerCase();
        case 'email':
          return (item.email || '').toLowerCase();
        case 'phone':
          return (item.phoneNumber || '').toLowerCase();
        default:
          return (item as any)[property];
      }
    };
    
    this.store
      .select(selectorAuth)
      .subscribe(auth => {
        if (auth != null && auth.userData != null) {
          this.userData = auth.userData;
        }
        if (this.userData == undefined) {
          this.userData = this.sessionStorageService.getItem("loginEventData")
        }
      });
    this.getCurrentLoggedInAccount()
    this.buildForm();
    this.resetAndLoadCertificates();
  }

  clearFilters() {
    this.offset = 0;
    this.limit = 10;
    this.lastSort = { active: '', direction: 'asc' };
    Object.keys(this.identificatorWEBForm.controls).forEach(key => {
      this.clearField(key, false);
    });
    this.paginator.pageIndex = 0;
  }

  getCurrentLoggedInAccount() {
    this.companyCmrId = this.sessionStorageService.getItem("businessAccountId");
  }
  get lang() {
    return this.translateService.currentLang;
  }

  getName(e:any) {
    if (e !== null) {
      return this.lang === 'bg' ? e.bg : e.en;
    } else {
      return '';
    }
  }

  buildForm() {
    const toDate = new Date();
    toDate.setDate(toDate.getDate() + 1);

    const fromDate = new Date(toDate);
    fromDate.setDate(toDate.getDate() - 7);

    this.identificatorWEBForm = this.formBuilder.group({
      fromDate: new FormControl(null),
      toDate: new FormControl(null),
      name: new FormControl(null),
      email: new FormControl(null, [Validators.email]),
      phone: new FormControl(null, [Validators.pattern(/^\+?[0-9]{10,15}$/)]),
      expired: new FormControl(this.expiredsList[0], [])
    }, { validators: this.dateRangeValidator });
  }

  dateRangeValidator(group: AbstractControl): ValidationErrors | null {
    const fromDate = group.get('fromDate')?.value;
    const toDate = group.get('toDate')?.value;

    if (fromDate && toDate) {
      const from = new Date(fromDate).setHours(0, 0, 0, 0);
      const to = new Date(toDate).setHours(0, 0, 0, 0);
      return to >= from ? null : { dateRangeInvalid: true };
    }
    return null;
  }

  // dateRangeValidator(group: AbstractControl): ValidationErrors | null {
  //   const fromDate = group.get('fromDate')?.value;
  //   const toDate = group.get('toDate')?.value;

  //   if (fromDate && toDate) {
  //     const from = new Date(fromDate);
  //     const to = new Date(toDate);
  //     const diffInDays = (to.getTime() - from.getTime()) / (1000 * 60 * 60 * 24);

  //     return diffInDays >= 7 ? null : { dateInvalid: true };
  //   }
  //   return null;
  // }

  limitToSevenDays = (date: Date | null): boolean => {
    if (!date) return false;

    const fromDate = this.identificatorWEBForm.get('fromDate')?.value;
    if (!fromDate) return true;

    const minDate = new Date(fromDate);
    const maxDate = new Date(fromDate);
    maxDate.setDate(maxDate.getDate() + 7);

    return date >= minDate && date <= maxDate;
  };


  genSortObject(sort: { active: string, direction: "asc" | "desc" }): any {
    if (!sort || !sort.active || !sort.direction) {
      return {};
    }
    let result = {}
    if (sort.active === 'registrationTime') {
      result = { sortDirectionByCreatedAt: sort.direction }
    } else if (sort.active === 'name') {
      result = { sortDirectionByName: sort.direction }
    }

    return result;
  }

  loadCertificates(sort: { active: string, direction: "asc" | "desc" } = { active: '', direction: 'asc' }): void  {
    this.lastSort = sort;
    this.isLoading = true;
    const datePipe = new DatePipe('en-US');
    const formValues = { ...this.identificatorWEBForm.value };
    formValues.expired = formValues.expired.value;
    Object.keys(formValues).forEach((key) => {
      const value = formValues[key];

      if (key !== 'expired') {
        if (value !== null && value !== '') {
          if (['fromDate', 'toDate'].includes(key)) {
            formValues[key] = datePipe.transform(value, 'dd.MM.yyyy');
          }
        } else {
          delete formValues[key];
        }
      }
    });

    const searchCriteria = {
      ...formValues,
      offset: this.offset / this.limit,
      limit: this.limit, 
      ...this.genSortObject(sort)
    };

    this.businessService.getTabHistoryWebIdentification(this.companyCmrId, searchCriteria)
      .pipe(takeUntil(this.cancelRequest$))
      .subscribe((response: any) => {
        this.allData = response.body?.data || [];
        if (response.body?.size != null) {
          this.totalCountPages = response.body.size;
          this.totalPages = Math.ceil(this.totalCountPages / this.limit);
        }
        // Just update the data for the table
        this.idintificatorDataSource.data = this.allData;
        this.isLoading = false;
      }, (error) => {
        console.error('Error loading data:', error);
        this.isLoading = false;
      });
  }

  isItDanger(row: any): WebIdentificationStatusResult {
    const statusSesionTranslate = this.translateService.instant('businessTexts.statusSession')
    return getWebIdentificationStatus(row, statusSesionTranslate);
  }

  cancelLoading(): void {
    this.cancelRequest$.next();
  }
  hasData(): boolean {
    return (this.idintificatorDataSource && this.idintificatorDataSource.data.length !== 0);
  }

  clearField(field: string, resetForm: boolean=true) {
    const control = this.identificatorWEBForm.get(field);
    if (control) {
      if (field === 'expired') {
        control.setValue(this.expiredsList[0]);
      }
      else {
        control.setValue(null);
      }
      control.markAsPristine();
      control.markAsUntouched();
      control.updateValueAndValidity();

      if (resetForm) {
        if (field !== 'fromDate' && field !== 'toDate') {
          this.resetAndLoadCertificates();
        }
      }
      else {
        this.allData = []
        this.idintificatorDataSource.data = this.allData;
      }
    }
  }

  resetAndLoadCertificates() {
    this.offset = 0;
    this.limit = 10;
    this.loadCertificates(this.lastSort);
  }

  onPaginateChange(event: PageEvent) {
    this.offset = event.pageIndex * event.pageSize;
    this.limit = event.pageSize;
    window.scrollTo(0, 0);
    this.loadCertificates(this.lastSort);
  }

  // Manual pagination properties for template binding
  get paginatorPageIndex(): number {
    return Math.floor(this.offset / this.limit);
  }

  viewDetailsDialog(row: any) {
    const selectedData = this.allData.find((item: any) => item.id === row.id);

    if (!selectedData) {
      console.warn('No data found for ID:', row.id);
      return;
    }

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.data = row
    dialogConfig.panelClass = 'panel-web-class-history';

    this.dialog.open(CloudWebIdentificationHistoryDetailsComponent, dialogConfig);
  }

  downloadUEI(callbackId: any) {
    this.callbackId = callbackId;
    this.businessService.getDownloadUEI(this.companyCmrId, this.callbackId).subscribe((res: any) => {
      if (res?.code === 'OK' && res?.data?.content) {
        const byteCharacters = atob(res.data.content);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/octet-stream' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'downloaded_UEI';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }
    }, (error) => {
      console.error('Download error', error);
    });
  }

//   onPaginateChange(event: PageEvent) {
// console.log('event',event)
//     // this.limit = event.pageSize;
//     // this.offset = event.pageIndex;
//     // this.loadCertificates();
//      this.limit = event.pageSize;
//   this.offset = event.pageIndex * this.limit;
//   this.totalPages =  Math.ceil(this.totalCountPages / this.limit)
//   this.loadCertificates();
//   }
}